module.exports = __webpack_public_path__ + "static/media/Plaza_Coronación.18c66bc0.jpg";